@if (schedulerService.branchView()) {
  <div class="hidden md:flex flex-col col-span-3 row-span-10 col-start-10 bg-gray-50 border border-gray-200 h-fit rounded">
    <div class="p-4 text-gray-700">
      <div class="font-semibold">
        {{getText()['branch'].side.title}}
      </div>
      <div class="text-xs">
        {{getText()['branch'].side.content}}
      </div>
    </div>
    
    <img src="/images/branchLocation.jpg"/>

    <button class="text-afcu-navy-800 text-xs p-4 cursor-pointer text-left" (click)="goTo(true)"> {{getText()['branch'].side.link}}</button>
  </div>
} @else {
  <div class="hidden md:flex flex-col gap-4 text-[#374151]">
    <div class="overflow-x-hidden rounded bg-gray-50 border border-gray-200">
      <div class="overflow-hidden h-36">
        <img [src]="branchService().imageUrl" class="h-36 w-full object-cover">
      </div>
      <div class="mt-2.5 p-4 flex flex-col gap-2.5">
        <div class="font-semibold text-base ">{{branchService().locationName}}</div>
        <div class="flex gap-2.5">
          <img src="/icons/address.svg" class="w-3 h-3"/>
          <div class="text-xs font-normal">{{branchService().address}}</div>
        </div>
        <div class="flex gap-2.5">
          <img src="/icons/phone.svg" class="w-3 h-3"/>
          <div class="text-xs font-normal">{{phoneNumber}}</div>
        </div>
        <button class="text-afcu-navy-800 text-xs cursor-pointer text-left" (click)="goTo(false)">{{getText()[target()].side.location}}</button>
      </div>
    </div>
    <div class="flex flex-col gap-2">
    @for (item of steps; let i = $index; track trackByOrder(i, item)) {
        <div class="flex gap-2 font-bold text-xs">
          <div [class]="(item.order <= activeStep && !item.complete) ? 'bg-[#00538B] font-bold text-white' : (item.complete) ? 'bg-[#4B5563]' : 'bg-[#D1D5DB] font-semibold text-black'" class="h-4 w-4 flex justify-center items-center rounded-full">
            @if (item.complete) {
              <img src="/icons/check.svg">
            } @else {
              {{item.order}}
            }
            </div>
            <div >
              <div [class]="(item.order <= activeStep) ? 'font-bold' : 'font-semibold'" class="text-[#1F2A37]">{{getText()[target()].side.steps[item.order-1]}}</div>
              @if (item.order <= activeStep && !item.complete){
                <div class="text-gray-400 text-xs font-normal">[{{getText()[target()].side.notSelected}}]</div>
              } @else if (item.complete) {
                <div class="text-gray-800 text-xs font-normal">{{stepSelected(item.mapping!)}}</div>
              }
            </div>
          
        </div>
      }
    </div>
  </div>  
}
